import { DotLoader } from "react-spinners"
import { handleLogin } from "../api/auth"
import { log } from "../utils/log_utils"
import { useLocation, useNavigate } from "react-router-dom"
import { BrainCircuit, Menu, LogOut } from "lucide-react"
import { NavbarItems } from "../components/NavbarItems"
import { useState, useRef, useEffect } from "react"
import { useAuth } from "../context/auth-context"
import { PopupMenu } from "../components/popups/PopupMenu"

export const Header = () => {

  const { user, loading, setLoading, logout } = useAuth()
  const [showSidebar, setShowSidebar] = useState(false)
  const [showProfileMenu, setShowProfileMenu] = useState(false)
  const profileBtnRef = useRef(null)

  const [isVisible, setIsVisible] = useState(true)
  const lastScrollY = useRef(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      
      // Always show at the top
      if (currentScrollY < 10) {
        setIsVisible(true)
      } else if (currentScrollY > lastScrollY.current) {
        // Scrolling down
        if (isVisible) setIsVisible(false)
      } else {
        // Scrolling up
        if (!isVisible) setIsVisible(true)
      }
      
      lastScrollY.current = currentScrollY
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [isVisible])


  const navigate = useNavigate()
  const location = useLocation()

  const loginClickHandler = async () => {
    setLoading(true)
    try {
      const redirectUrl = encodeURIComponent(location.pathname + location.search);
      await handleLogin(redirectUrl)
    } catch (error) {
      log(error, 'loginClickHandler')
    }
    finally{
      setLoading(false)
    }

  }
  
  const redirectHome = () => {
    if(user){
      navigate("/")
    }
  }

    return (
      <>
        <header className={`w-full bg-white shadow-sm z-40 sticky top-0 transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
          <div className="container mx-auto px-4 py-2 flex justify-between items-center">
            
            <div className="flex text-indigo-600 items-center gap-2 pace-x-4 cursor-pointer" onClick={redirectHome} >
              <BrainCircuit className="mr-2 hidden md:flex" />
              <Menu onClick={(e) => { setShowSidebar(!showSidebar)}} className="flex md:hidden" />
              <span className=" font-bold text-2xl">ResumeAI</span>
            </div>

          {/* TOP NAVBAR FOR WEB */}
            <div className="hidden md:flex items-center h-16 w-full text-white px-4">
              <NavbarItems />
            </div>
            
            <div>
              {
                loading ? <DotLoader size={40} loading={loading} color="#4f69e5" />
                :
                  (user ? 
                  <div className="relative" ref={profileBtnRef}>
                    <div className="text-indigo-800 font-semibold cursor-pointer" onClick={() => setShowProfileMenu(!showProfileMenu)}>
                      <img className='rounded-full w-14 object-contain' src={user?.meta?.picture} alt={user?.meta?.given_name} />
                    </div>
                    {showProfileMenu && (
                      <PopupMenu 
                          moreMenuResumeId={showProfileMenu}
                          setMoreMenuResumeId={setShowProfileMenu}
                          moreBtnRef={profileBtnRef}
                          optionsBtnList={[
                              { label: "Logout", onClick: () => { setShowProfileMenu(false); logout(); navigate("/"); } }
                          ]}
                          className="absolute right-0 top-12 z-50 bg-white border rounded shadow-lg w-32 overflow-hidden"
                      />
                    )}
                  </div> 

                  :
                  <button onClick={loginClickHandler} className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition whitespace-nowrap">
                  Sign In
                </button>)
                }
            </div>
          </div>
        </header>

        {/* SIDEBAR FOR MOBILE */}
        {showSidebar && (
          <div
            title="sidebar-backdrop"
            onClick={() => setShowSidebar(false)}
            className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm z-40 md:hidden"
          />
        )}
        <div
          className={`fixed top-0 left-0 z-50 h-screen w-64 bg-gradient-to-b from-white to-indigo-50 shadow-xl transform transition-transform duration-300 ease-in-out flex flex-col ${
            showSidebar ? "translate-x-0" : "-translate-x-full"
          } md:hidden`}
        >
          <div className="flex text-indigo-600 items-center gap-2 cursor-pointer p-4 border-b border-gray-100" onClick={redirectHome}>
            <BrainCircuit className="mr-2" />
            <span className="text-indigo-600 font-bold text-2xl">ResumeAI</span>
          </div>
          
          <div className="flex-1 overflow-y-auto">
            <NavbarItems setShowSidebar={setShowSidebar} />
          </div>

          {user && (
            <div className="p-4 mt-auto border-t border-gray-100">
              <button 
                onClick={() => { setShowSidebar(false); logout(); navigate("/"); }} 
                className="flex items-center w-full py-3 px-4 rounded-lg bg-gray-800 text-white hover:bg-gray-900 transition-colors font-medium"
              >
                <LogOut className="mr-3" size={20} />
                Logout
              </button>
            </div>
          )}
        </div>
      </>
    )
}